module.exports = __webpack_public_path__ + "static/media/setup.c9bd74dd.svg";